<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-show="myLevel >= 10"
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="員工"
                  v-model="form.UserID"
                  :rules="formRules.UserID"
                ></v-autocomplete>
                <v-textarea
                  v-model="form.Content"
                  rows="3"
                  label="訊息"
                  :rules="formRules.Content"
                ></v-textarea>
                <v-text-field
                  v-model="form.Days"
                  label="天數"
                  type="number"
                  step="0.5"
                  min="-1000000"
                  max="10000000"
                  :rules="formRules.Days"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >送出</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Content: "",
      Days: 0,
    }
  }),
  computed: {
    formRules() {
      return {
        Days: [v => !!v || "請輸入天數"],
        Content: [v => !!v || "請輸入原因"],
        UserID: [v => !!v || "請選擇員工"],
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.compensatoryTime.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    userOptions() {
      const findUserDepartment = user => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };
      const findUserDepartmentID = user =>
        (this.userDepartments.find(o => o.UserID == user.ID) || {})
          .DepartmentID;
      return this.activeUsers
        // .filter(o => o.ID != this.me.ID)
        .filter(o => AppDataSetting.findUserLevel(this, o) < 10)
        .filter(o => findUserDepartmentID(o) == this.myDepartment.ID)
        .map(o => ({ ID: o.ID, Name: `${o.Profile.Name} (${findUserDepartment(o).Name})` }));
    },
    ...mapGetters([
      "activeUsers",
      "userPositions",
      "userDepartments",
      "me",
      "myLevel",
      "myDepartment",
      "departments"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.form.Hours = this.form.Days*8

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.compensatoryTime
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.compensatoryTime.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.compensatoryTime
          .add(this, this.form)
          .then(res => {
            this.$store.state.compensatoryTime.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(this.$store.state.compensatoryTime.list[this.editingIdx])
        );
        this.form.Days = this.form.Hours/8
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (this.myLevel < 10) this.form.UserID = this.me.ID
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.compensatoryTime.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>